"use strict";

import { initMenu } from '../components/menu.js';
import { initBanner } from '../components/banner.js';
import { initFooter } from '../components/footer.js';
import { initGuestConfirmationForm } from '../components/guest-confirmation-form.js';

export function initweddingKitty() {
  console.log("Initialisation de la page weddingKitty");
  initBanner();
  initMenu();
  initGuestConfirmationForm();
  initFooter();
}

module.exports = { initweddingKitty };
